/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Months_JanuaryInputs */

const es_months_january = /** @type {(inputs: Months_JanuaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enero`)
};

const en_months_january = /** @type {(inputs: Months_JanuaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`January`)
};

/**
* | output |
* | --- |
* | "January" |
*
* @param {Months_JanuaryInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const months_january = /** @type {((inputs?: Months_JanuaryInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Months_JanuaryInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_months_january(inputs)
	return en_months_january(inputs)
});
export { months_january as "months.january" }